import { render, staticRenderFns } from "./ApexReferralChart.vue?vue&type=template&id=e7271f66&scoped=true&"
import script from "./ApexReferralChart.vue?vue&type=script&lang=js&"
export * from "./ApexReferralChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7271f66",
  null
  
)

export default component.exports